<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <app-page-header [urlName]="'Banco'" urlPath="bancos"></app-page-header>

    <p-card class="md:max-w-250">
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Editar/Incluir Banco</h1>

            <div class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end">
                <app-input
                    id="codigo"
                    label="Código"
                    formControlName="Codigo"
                    class="sm:col-span-4"
                ></app-input>

                <app-input
                    id="nomebanco"
                    label="Nome do Banco"
                    formControlName="Nome"
                    class="sm:col-span-8"
                ></app-input>

                <app-input
                    id="url"
                    label="URL"
                    formControlName="Url"
                    class="sm:col-span-12"
                ></app-input>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>
